import { ENUM_LAYOUT_TYPES, ENUM_PATHS } from "@shared/routing";
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./protected-route";
import { ALL_APP_ROUTES_LIST } from "./config";
import { RootAdminLayout, RootLayout } from "@widgets/layouts";
import { Maintenance } from "@widgets/maintenance";

const IS_MAINTENANCE = import.meta.env.VITE_IS_MAINTENANCE === "true";

const ROOT_ROUTES_LIST = ALL_APP_ROUTES_LIST.filter(
  (route) => route.layout === ENUM_LAYOUT_TYPES.ROOT,
).map((route) => ({
  path: route.path,
  element: <ProtectedRoute route={route} />,
}));

const ADMIN_ROUTES_LIST = ALL_APP_ROUTES_LIST.filter(
  (route) => route.layout === ENUM_LAYOUT_TYPES.ADMIN,
).map((route) => ({
  path: route.path,
  element: <ProtectedRoute route={route} />,
}));

export const router = createBrowserRouter(
  IS_MAINTENANCE
    ? [{ path: "*", element: <Maintenance /> }]
    : [
        {
          path: ENUM_PATHS.MAIN,
          element: <RootLayout />,
          children: ROOT_ROUTES_LIST,
        },
        {
          path: ENUM_PATHS.MAIN,
          element: <RootAdminLayout />,
          children: ADMIN_ROUTES_LIST,
        },
      ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);
